export const IMAGES = {
  heroFlinders:
    "https://images.unsplash.com/photo-1720347653553-f6974224581b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwxfHxmbGluZGVycyUyMHN0cmVldCUyMHN0YXRpb24lMjBtZWxib3VybmV8ZW58MHx8fHwxNzg1MTQ4NDgzfDA&ixlib=rb-4.1.0&q=85",
  martin:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_marvellous-melbourne/artifacts/qyvpgo9w_image5.jpeg",
  martinMuseum:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_marvellous-melbourne/artifacts/n3tz649y_image8%281%29.jpeg",
  martinStreet:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_marvellous-melbourne/artifacts/iuk9xqfo_image3.jpeg",
  martinPointing:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_marvellous-melbourne/artifacts/hpa2n2fz_image13%281%29.jpeg",
  martinStPauls:
    "https://customer-assets-m6fa6gv7.emergentagent.net/job_marvellous-melbourne/artifacts/uqta2sb5_image14.jpeg",
  tram:
    "https://images.unsplash.com/photo-1674393027244-9aef430fd90c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzN8MHwxfHNlYXJjaHwzfHxmbGluZGVycyUyMHN0cmVldCUyMHN0YXRpb24lMjBtZWxib3VybmV8ZW58MHx8fHwxNzg1MTQ4NDgzfDA&ixlib=rb-4.1.0&q=85",
  collinsDome:
    "https://images.unsplash.com/photo-1557750247-f7f5a1f29ecd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxoaXN0b3JpYyUyMGNvbGxpbnMlMjBzdHJlZXQlMjBtZWxib3VybmUlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzg1MTQ4NDgzfDA&ixlib=rb-4.1.0&q=85",
  parliament:
    "https://images.unsplash.com/photo-1766050588705-019eec232896?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxwYXJsaWFtZW50JTIwaG91c2UlMjBtZWxib3VybmV8ZW58MHx8fHwxNzg1MTQ4NDgzfDA&ixlib=rb-4.1.0&q=85",
  paperTexture:
    "https://images.unsplash.com/photo-1648717008621-ee7e6acfe270?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwxfHxvbGQlMjB2aW50YWdlJTIwbWFwJTIwdGV4dHVyZSUyMHNlcGlhfGVufDB8fHx8MTc4NTE0ODQ4M3ww&ixlib=rb-4.1.0&q=85",
};

export const GALLERY = [
  { src: IMAGES.martinPointing, alt: "Martin, sunglasses on, pointing out a Melbourne detail mid-tour", span: "bento-tall" },
  { src: IMAGES.heroFlinders, alt: "Flinders Street Station clock tower", span: "bento-wide" },
  { src: IMAGES.martinMuseum, alt: "Martin mid-story at the Melbourne Museum steps" },
  { src: IMAGES.collinsDome, alt: "Collins Street heritage dome" },
  { src: IMAGES.martinStPauls, alt: "Martin near St Paul's Cathedral in the CBD" },
  { src: IMAGES.tram, alt: "Melbourne heritage tram" },
  { src: IMAGES.martin, alt: "Martin outside Victorian Parliament House" },
  { src: IMAGES.martinStreet, alt: "Martin gesturing through a CBD side street" },
  { src: IMAGES.parliament, alt: "Victorian Parliament House" },
];

export const BANK_DETAILS = {
  account_name: "Martin Costello",
  bsb: "013-711",
  account_number: "815852255",
  reference_hint: "Please use your name or booking reference so Martin can match the payment.",
};

export const DIRECT_BOOKING = {
  phone_display: "0422 007 703",
  phone_link: "+61422007703",
  email: "Mmmwt35@gmail.com",
};

// Google Business Profile review link.
// Set this once Martin's Google Business Profile is live — the "Leave a Google Review"
// CTA on /leave-a-review will only appear when this URL is populated.
// Format: "https://g.page/r/<your-place-id>/review"
export const GOOGLE_REVIEW_URL = "https://g.page/r/CfY9xXeX0WX-EBM/review";

export const TESTIMONIALS = [
  {
    quote:
      "Martin is Marvellous, will book again, 100%.",
    author: "Lucas B.",
    role: "Metro Train Driver",
  },
  {
    quote:
      "Build this man a statue. My school students were engaged, entertained and best of all — silent.",
    author: "Daniel M.",
    role: "Humanities and Year Level Coordinator",
  },
  {
    quote:
      "Best walk, best presenter, best gift for my team at the office — cannot wait to do it again.",
    author: "Adrian L.",
    role: "Sales assistant and entrepreneurial maestro",
  },
  {
    quote: "Martin is Melbourne.",
    author: "Tane R.",
    role: "Melbourne icon and Street Artist",
  },
  {
    quote: "Martin's making history great again.",
    author: "Ben W.",
    role: "High-Flying Corporate",
  },
  {
    quote: "Wow, I never knew history could be so fascinating.",
    author: "Grace A.",
    role: "A northsider in the know",
  },
];

export const FAQS = [
  {
    q: "Where does the tour start and finish?",
    a: "We meet at Federation Square, in front of the big screen, and end near Parliament House on Spring Street. Roughly 2 kilometres, all in the CBD.",
  },
  {
    q: "How long is the tour?",
    a: "Between 1h 45m and 2h depending on the group and how much Martin gets asked. Regular gentle stops throughout.",
  },
  {
    q: "What's the fitness level?",
    a: "Casual walking on flat city footpaths. Comfortable shoes recommended. The tour runs rain, hail or shine — pack a jacket.",
  },
  {
    q: "Are the tours suitable for children?",
    a: "Absolutely. Under 12s walk free with a paying adult. School group tours are tailored to curriculum level on request.",
  },
  {
    q: "How do I pay?",
    a: "Individual bookings can be arranged on the day (cash or card via Martin). Corporate and school tours are invoiced after enquiry.",
  },
  {
    q: "Can we do a private / custom tour?",
    a: "Yes — Martin runs private group tours across corporate offsites, birthdays, family reunions and school excursions. Use the enquiry form.",
  },
  {
    q: "Is there a minimum number of people?",
    a: "Yes. A minimum of 3 guests is required for a public individual tour to run. If numbers fall below that on your chosen day, Martin will contact you to reschedule or offer a full refund — no fuss.",
  },
];

export const ROUTE_STOPS = [
  { street: "Swanston Street", note: "Where Melbourne first drew a line on a map — 1837." },
  { street: "Flinders Street", note: "The clocks under which every Melburnian has waited." },
  { street: "Collins Street", note: "Boom-era banks, hidden arcades and a very Parisian dome." },
  { street: "Russell Street", note: "The old gaol, the trials, and the tram lines that trace the vanished cables." },
  { street: "Exhibition Street", note: "From gold rush theatres to lane-way espresso bars." },
];

export const SCHEDULE = [
  { day: "Friday", time: "11:00 AM – 12:45 PM" },
  { day: "Last Sunday of the month", time: "1:00 PM – 3:00 PM" },
];

export const SATURDAY_NOTE = "Saturday bookings negotiable — email or call Martin.";

// Reviews pulled from Google & TripAdvisor. Update this list any time — the site reflects it instantly.
export const REVIEWS = [
  {
    quote: "Martin's storytelling made Melbourne feel brand new to me — even after living here for 15 years. Absolute must-do.",
    author: "Sophie H.",
    date: "November 2025",
    source: "Google",
    rating: 5,
  },
  {
    quote: "We booked this for my father's 70th and the whole family were spellbound. Martin is a walking treasure trove.",
    author: "James T.",
    date: "October 2025",
    source: "TripAdvisor",
    rating: 5,
  },
  {
    quote: "Best two hours we spent in Melbourne. Warm, witty, informative — Martin should be a national heritage listing.",
    author: "Priya R.",
    date: "September 2025",
    source: "Google",
    rating: 5,
  },
  {
    quote: "Booked for my team offsite. Everyone was raving about it for weeks. Martin tailored it perfectly for us.",
    author: "Elise D.",
    date: "August 2025",
    source: "TripAdvisor",
    rating: 5,
  },
];

// -----------------------------------------------------------
// Marvellous Melbourne Quiz — 10 questions curated by Martin
// -----------------------------------------------------------
export const QUIZ_QUESTIONS = [
  {
    id: 1,
    text: "What year did John Batman arrive in Melbourne?",
    options: [
      { key: "a", text: "1830" },
      { key: "b", text: "1835" },
      { key: "c", text: "1840" },
      { key: "d", text: "1845" },
    ],
    correct: "b",
  },
  {
    id: 2,
    text: "What year was the Sorrento Settlement?",
    options: [
      { key: "a", text: "1788" },
      { key: "b", text: "1790" },
      { key: "c", text: "1803" },
      { key: "d", text: "1813" },
    ],
    correct: "c",
  },
  {
    id: 3,
    text: "Which convict escaped from that settlement?",
    options: [
      { key: "a", text: "Lord Melbourne" },
      { key: "b", text: "Ned Kelly" },
      { key: "c", text: "Mick Martin" },
      { key: "d", text: "William Buckley" },
    ],
    correct: "d",
  },
  {
    id: 4,
    text: "What was the name of Martin's Great-Great-Great Grandfather who was sent to jail for electoral fraud?",
    options: [
      { key: "a", text: "Parentage unknown" },
      { key: "b", text: "Tim Costello" },
      { key: "c", text: "Paul Costello" },
      { key: "d", text: "Patrick Costello" },
    ],
    correct: "d",
  },
  {
    id: 5,
    text: "What year was Flinders Street Station built?",
    options: [
      { key: "a", text: "1844" },
      { key: "b", text: "1944" },
      { key: "c", text: "1864" },
      { key: "d", text: "1854" },
    ],
    correct: "d",
  },
  {
    id: 6,
    text: "What was the name of the alleged Jack the Ripper?",
    options: [
      { key: "a", text: "Albert Williams" },
      { key: "b", text: "Moira Deeming" },
      { key: "c", text: "Frederick Deeming" },
      { key: "d", text: "I cannot remember" },
    ],
    correct: "c",
  },
  {
    id: 7,
    text: "What was the year of the Eureka Stockade?",
    options: [
      { key: "a", text: "1854" },
      { key: "b", text: "1954" },
      { key: "c", text: "1901" },
      { key: "d", text: "1927" },
    ],
    correct: "a",
  },
  {
    id: 8,
    text: "What year/s did the famous Burke and Wills expedition take place?",
    options: [
      { key: "a", text: "It didn't" },
      { key: "b", text: "1850 / 1851" },
      { key: "c", text: "1860 / 1861" },
      { key: "d", text: "1870 / 1871" },
    ],
    correct: "c",
  },
  {
    id: 9,
    text: "What was the name of Dame Nellie Melba's father?",
    options: [
      { key: "a", text: "Neville Melba" },
      { key: "b", text: "Banjo Paterson" },
      { key: "c", text: "Howard Mitchell" },
      { key: "d", text: "David Mitchell" },
    ],
    correct: "d",
  },
  {
    id: 10,
    text: "Which Premier was rumoured (probably falsely) to have visited Madame Brussels with the parliamentary mace?",
    options: [
      { key: "a", text: "Ted Baillieu" },
      { key: "b", text: "Dan Andrews" },
      { key: "c", text: "Henry Bolte" },
      { key: "d", text: "Thomas Bent" },
    ],
    correct: "d",
  },
];

export const SCORE_MESSAGES = {
  10: "You are a Melbourne Marvel.",
  9: "Oh my days, you could take the tour.",
  8: "High-Distinction.",
  7: "Sharp learning, my friend.",
  6: "You know your history.",
  5: "Not too bad.",
  4: "Pay more attention in history.",
  3: "Deary me.",
  2: "Please do the tour again.",
  1: "You are not serious, are you?",
  0: "Book the tour immediately — this is an intervention.",
};

// -----------------------------------------------------------
// School Packages — curriculum-aligned CBD walks (ACARA V9)
// Flat $599 per program, up to ~50 students per cohort
// -----------------------------------------------------------
export const ACARA_V9_URL = "https://v9.australiancurriculum.edu.au/";

export const SCHOOL_PACKAGES = [
  {
    id: "year-5",
    year: "Year 5",
    title: "The Foundations of Melbourne",
    tagline: "How a river bank became a city.",
    description:
      "Before the trams, the towers or the trains — what was Melbourne? Your Year 5s walk in the footsteps of the Wurundjeri Woi Wurrung, meet John Batman's boat at the exact bend of the Yarra where it all began, and discover why 1835 changed everything. Colonial history brought to life through storytelling no textbook can match.",
    curriculum: {
      subject: "HASS – History",
      strand: "The First Contacts & Colonial Australia",
      standards: ["AC9HS5K01", "AC9HS5K02"],
    },
    accent: "burgundy",
  },
  {
    id: "year-6",
    year: "Year 6",
    title: "Democracy and the Gold Rush",
    tagline: "From diggers to democracy — 1854 to 1901.",
    description:
      "In under two hours, your Year 6s trace how Victoria's gold rush turned Melbourne into the second-richest city in the British Empire — and how the Eureka Rebellion of 1854 planted the seeds of Australian democracy. Standing where miners marched and protesters petitioned, students see Federation history not as chapter headings but as a civic story alive under their feet.",
    curriculum: {
      subject: "HASS – History & Civics",
      strand: "Australia as a Nation",
      standards: ["AC9HS6K01", "AC9HS6K02"],
    },
    accent: "gold",
  },
  {
    id: "year-7",
    year: "Year 7",
    title: "Liveability in Melbourne",
    tagline: "What builds the world's most liveable city?",
    description:
      "Your Year 7s explore Melbourne through the geographer's lens — climate, transport, green space, culture — and meet the real people (planners, protesters, publicans and publishers) who bent the shape of the CBD to their will. Textbook liveability indicators, brought to life on the exact streets they describe.",
    curriculum: {
      subject: "Geography",
      strand: "Place and Liveability",
      standards: ["AC9HG7K04"],
    },
    accent: "forest",
  },
  {
    id: "year-8",
    year: "Year 8",
    title: "Australian Political Parties",
    tagline: "The birthplace of Labor, Liberal, and everything in between.",
    description:
      "From the Trades Hall birthplace of the ALP to the Melbourne Club where the Liberals gathered, from Deakin to Menzies to Whitlam — your Year 8s meet the leaders and ideologies that shaped modern Australian parliament, standing right where they lived, spoke, and schemed. Civics comes alive on the pavement.",
    curriculum: {
      subject: "Civics and Citizenship",
      strand: "Government and Democracy",
      standards: ["AC9HC8K01", "AC9HC8K03"],
    },
    accent: "burgundy",
  },
  {
    id: "year-9",
    year: "Year 9",
    title: "Melbourne During War",
    tagline: "1916. The city that split a nation.",
    description:
      "Australia is bleeding on the Western Front. At home, Prime Minister Billy Hughes and Archbishop Daniel Mannix are tearing the nation apart over one word: conscription. Your Year 9s stand on the exact CBD steps where each man rallied crowds of tens of thousands, and understand why WWI shaped 20th-century Australia more than any single event. The war didn't only happen at Gallipoli — it happened on these streets.",
    curriculum: {
      subject: "History",
      strand: "Making a Better World / WWI",
      standards: ["AC9HH9K01", "AC9HH9K02"],
    },
    accent: "forest",
  },
  {
    id: "year-10-12",
    year: "Year 10–12",
    title: "Multifaith, Mindful Melbourne",
    tagline: "One city. Every worldview. Two thousand years of belief.",
    description:
      "From the vaulted stone of St Paul's Cathedral to the golden dome of a Sikh Gurdwara, from Melbourne's oldest synagogue to the mindfulness halls of the CBD Buddhist community — your senior students trace how faith has shaped Melbourne's laws, politics, architecture and social fabric. Whether they're VCE Philosophy students, Religion & Society scholars, or simply curious — atheist, agnostic or devout — this walk speaks to every worldview.",
    curriculum: {
      subject: "Senior HASS / Religion & Society / Philosophy",
      strand: "Belief systems, ethics and civic identity",
      standards: ["VCE Religion & Society U1-4", "VCE Philosophy"],
    },
    accent: "gold",
  },
];

// -----------------------------------------------------------
// Corporate Packages — team-day walks with 3 pricing tiers
// -----------------------------------------------------------
export const CORPORATE_TIERS = [
  { id: "tier-10", label: "Up to 10 people",       max: 10,  price_aud: 499 },
  { id: "tier-20", label: "Up to 20 people",       max: 20,  price_aud: 799 },
  { id: "tier-30", label: "Up to 30 people",       max: 30,  price_aud: 999 },
  { id: "tier-40", label: "40 or more people",     max: 200, price_aud: 1299 },
];

export const CORPORATE_PACKAGES = [
  {
    id: "roaring-80s",
    icon: "top-hat",
    title: "The Roaring 80s",
    tagline: "Marvellous Melbourne at its glittering, ruinous best.",
    description:
      "In 1888, Melbourne was declared the greatest city on earth. By 1893, half its banks had collapsed and its wealthiest men were bankrupt. In two hours through the Golden Mile, your team traces the boom-and-bust decade that built our skyline — and meets the bankers, buccaneers, and land-speculators who scaled empires that fell harder than any market since. An unforgettable masterclass in optimism, greed, and reinvention.",
    highlights: [
      "Walk the Golden Mile of Collins Street",
      "The 1880s land boom & 1890s bank crash",
      "Real lessons in risk that resonate in any boardroom",
    ],
    accent: "gold",
  },
  {
    id: "sinister-gangster",
    icon: "mask",
    title: "Sinister Gangster Melbourne",
    tagline: "A look at the dark side of this most wonderful city.",
    description:
      "Beneath the trams and the trenchcoats sits Melbourne's other biography. Infanticide in the Yarra, the Baby Farmer trials, the opium dens of Little Bourke Street, Squizzy Taylor's Fitzroy, and the razor gangs who ran the CBD before the police did. Two hours through the city's shadow side — dark, wickedly entertaining, and a story your team will still be dining out on months later. Perfect as an after-work walk with drinks to finish.",
    highlights: [
      "Melbourne's most infamous crimes",
      "The gangs and the ganglords who built the underworld",
      "Ideal as an after-hours team offsite",
    ],
    accent: "burgundy",
  },
  {
    id: "mindful-multifaith",
    icon: "temple",
    title: "Mindful, Multifaith Melbourne",
    tagline: "A spiritual walk through the oneness of a great city.",
    description:
      "From Daniel Mannix's Catholic cathedral to Patrick Murdoch's Scots' Church, from Billy Graham's tent revivals to Pope John Paul II and the Dalai Lama himself — Melbourne has hosted almost every great religious voice of the last century. This walk explores how the sacred and the civic shaped the CBD together. A reflective, inclusive experience that speaks to every worldview — atheist, agnostic, or devout.",
    highlights: [
      "Melbourne's greatest religious figures & moments",
      "Sacred and civic architecture side by side",
      "A reflective, inclusive team experience",
    ],
    accent: "forest",
  },
  {
    id: "love-of-cbd",
    icon: "briefcase",
    title: "A Love of the CBD",
    tagline: "The walk that brings your team back to the city.",
    description:
      "Since 2020, Melbourne's CBD has been quieter than any of us remember — but the city has always found a way back. In two hours, your team walks the streets that survived the gold rush, the depression, two world wars and a pandemic, and hears the human stories behind Melbourne's greatest comebacks. A history and culture walk designed to rekindle pride, spark connection, and remind your people why the office, the laneways, and the coffee downstairs are worth showing up for. Perfect for return-to-office kick-offs, team culture days, and welcoming new hires to the city.",
    highlights: [
      "Curated for return-to-office and team culture days",
      "History, culture and business — why the CBD still matters",
      "Great morning walk before lunch, or afternoon before drinks",
    ],
    accent: "navy",
  },
  {
    id: "end-of-year",
    icon: "glass",
    title: "End-of-Year Work Celebration",
    seasonal: "Christmas & end-of-year",
    tagline: "Fun, engaging and educational — with two very well-earned pub stops.",
    description:
      "A marvellous afternoon with Martin exploring Melbourne's landmarks — an incredible journey through 191 years of Melbourne stories and the personalities who helped shape this great city. About 2.5 hours, with a beer with Chloe at Young & Jackson, a sing-along with Dame Nellie Melba at Hickens Hotel, and a relaxed finish at the Imperial Hotel. A fitting toast to another year well done.",
    highlights: [
      "Two famous CBD pub stops + finish at the Imperial Hotel",
      "Approx. 2.5 hours · afternoon start, time agreed when booking",
      "Drinks & lunch paid directly at the pubs — price covers Martin's tour",
    ],
    stops: [
      "Federation Square — meet & greet, acknowledgement of country",
      "The Founding of Melbourne",
      "Melbourne's Major Players",
      "Young & Jackson — a beer with Chloe",
      "Melbourne Town Hall and its sinister connection",
      "Bourke Street Riot, 1923",
      "Hickens Hotel — singing with Dame Nellie Melba",
      "The Gun Alley Murder",
      "Meet the Murdochs",
      "Marvellous Melbourne and the 1890s Depression",
      "Finish at the Imperial Hotel",
    ],
    accent: "holly",
  },
];

export const BLOCKED_DATES = [
  "2026-08-14", // Martin unavailable
  "2026-08-16", // Martin unavailable
  "2026-08-02", // Sunday
  "2026-08-28", // Friday
  "2026-08-30", // Sunday
  "2026-09-04", // Friday · private group
  "2026-09-06", // Sunday · Martin unavailable
  "2026-09-25", // Friday
  "2026-09-27", // Sunday
];
